import { FlaskConical, Sparkles } from "lucide-react";
import { cn } from "../../../lib/cn";

/**
 * "Sample" — staging sample content (`isSample`), so nobody mistakes a seeded
 * persona's story for a real parent's. Small and quiet on purpose.
 */
export function SampleChip({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-neutral-200 bg-white/90 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-neutral-600",
        className,
      )}
      title="Sample content for our preview — not a real member's story"
    >
      <FlaskConical className="h-3 w-3" aria-hidden />
      Sample
    </span>
  );
}

/** "Best-practice guide" — written and reviewed by the Leena's List team (kind: "guide"). */
export function GuideChip({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-violet-100 bg-violet-50 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-violet-700",
        className,
      )}
    >
      <Sparkles className="h-3 w-3" aria-hidden />
      Best-practice guide
    </span>
  );
}
